export default __webpack_public_path__ + "static/epilogue-bfd461ec76d9cfaaea0bec1c8c1089e0.svg";